import React, { FC, useContext, useState, useEffect } from "react";

import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import "./styles.css";
import ButtonComponent from "../buttons/ButtonComponent";
import RecoveryRequestForm from "./RecoveryRequestForm";

/**
 * DEV-81 (`ФРН-Q1`): форма входа выводится ровно в одном месте дерева — в
 * `Layout.tsx`, который показывает её на любой странице без входа. Вставленная
 * ещё и в `Home.tsx`, она ложилась на себя (обе `position: absolute`), и
 * «Забыли пароль?» переключал верхнюю форму — из-под неё были видны
 * «АВТОРИЗАЦИЯ» и «Войти» нижней.
 *
 * Поле входа — адрес: `/login` и так принимает только email, поэтому `type="email"`.
 *
 * п. 32 (ФЗ-152, `РГ-01`): пароль в `localStorage` не хранится — «запомнить меня»
 * помнит только адрес. Ключ `password`, оставшийся у прежних версий, удаляется
 * **при старте приложения** (`32.1`, `utils/legacyPasswordKey`), а не здесь: форму
 * входа вошедший человек не открывает вовсе, и чистка в форме до него не дошла бы.
 */

const LoginForm: FC = () => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [showRecovery, setShowRecovery] = useState<boolean>(false);
  const { store } = useContext(Context);

  useEffect(() => {
    // Загрузка сохранённых данных при монтировании: адрес и признак «запомнить».
    const savedEmail = localStorage.getItem("email");
    const savedRememberMe = localStorage.getItem("rememberMe");

    if (savedRememberMe === "true") {
      setEmail(savedEmail || "");
      setRememberMe(true);
    }
  }, []);

  const logIn = (e: React.FormEvent) => {
    e.preventDefault();
    if (rememberMe) {
      // п. 32: «запомнить меня» хранит только адрес, пароля здесь нет.
      localStorage.setItem("email", email);
      localStorage.setItem("rememberMe", "true");
    } else {
      // Удаляем сохранённые данные если галочка снята
      localStorage.removeItem("email");
      localStorage.removeItem("rememberMe");
    }
    store.login(email, password);
  };

  if (showRecovery) {
    return <RecoveryRequestForm onClose={() => setShowRecovery(false)} />;
  }

  return (
    <div className="loginForm_conteiner">
      <div className="loginform_title">АВТОРИЗАЦИЯ</div>
      <form onSubmit={logIn}>
        <div className="loginForm_form">
          <label htmlFor="login">логин или email:</label>
          <input
            className="loginForm_input"
            id="login"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoCapitalize="none"
          />
        </div>
        <div className="loginForm_form">
          <label htmlFor="password">Пароль:</label>
          <input
            className="loginForm_input"
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="loginForm_remember">
          <input
            className="loginForm_form_remember_input"
            type="checkbox"
            id="rememberMe"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          />
          <label style={{ alignContent: "center" }} htmlFor="rememberMe">
            Запомнить меня
          </label>
        </div>
        <div className="loginForm_forgot">
          <button
            type="button"
            className="recovery_link"
            onClick={() => setShowRecovery(true)}
          >
            Забыли пароль?
          </button>
        </div>
        <div className="loginForm_btns">
          <ButtonComponent title="Войти" size="100%" />
        </div>
      </form>
      {store.authError ? (
        <div className="Error_message">
          <div className="Error_message_title">Ошибка:</div>
          {store.authError}
        </div>
      ) : null}
    </div>
  );
};

export default observer(LoginForm);
